import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { SystemLoader } from './shared/components/system-loader/system-loader';
import { TranslationService } from './services/translation.service';
import { AuthService } from './services/auth-service';
import { AppStoreService } from './store/ngrx-signal.store';
import { ENTITIES } from './store/entities.registry';
import { LOGGED_IN_USER } from './modules/user-profile/user-profile.models';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast, SystemLoader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('mel-frontend');
  private readonly auth = inject(AuthService);
  private readonly store = inject(AppStoreService);

  constructor(private readonly translationService: TranslationService) {
    this.translationService.init();
  }

  ngOnInit() {
    this.restoreUserSession();
  }

  private restoreUserSession() {
    if (this.auth.alreadyLoggedIn()) {
      this.store.query(ENTITIES.LOGIN_USER, LOGGED_IN_USER);
    }
  }
}
